import { Component, OnInit }       from '@angular/core';
import { ActivatedRoute,Router,Params }  from '@angular/router';
import { Location }        from '@angular/common';

import { DoctorService } from '../../services/doctors/doctor.service';
import { Doctor } from '../../classes/doctor';
import { Call } from '../../classes/call';

import { FilterService } from '../../services/calls/filter.service';



import { UserDetailComponent } from '../../users/detail/user-detail.component';
import { AllCallsComponent } from '../../calls/allCalls.component';
import { ProviderService } from '../../services/providers/provider.service';


import * as _ from 'lodash';
import { CallService } from '../../services/calls/call.service';
import { SpecialtiesService } from '../../services/specialties/specialties.service';
import { AppConfig } from '../../app.config';
import { Auth } from '../../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'call-detail',
  templateUrl: 'doctor-call-detail.component.html',
  styleUrls: [ '../../users/users.component.css' ]
})

export class DoctorCallDetailComponent  extends AllCallsComponent implements OnInit{


  loadingInfo:boolean=true
  doctor:Doctor;
  info:any[];
  fromDate:Date;
  toDate:Date
  callStates = [];
  searchStatus;


  constructor(protected doctorService: DoctorService,
              protected route: ActivatedRoute,
              protected router: Router,
              protected location: Location,
              protected filterService:FilterService,
              protected providerService:ProviderService,
              protected specialtiesService:SpecialtiesService,
              protected doctorsService: DoctorService,
              protected callService:CallService,
              protected config: AppConfig,
              protected auth: Auth) {
                 super(doctorService,location,router,filterService,providerService,specialtiesService,doctorsService,callService,config,auth);
              }

  ngOnInit(): void {
    this.route.params
      .switchMap((params: Params) => this.doctorsService.getOne(params['id'])
      )
      .subscribe((doctor) => {

        this.doctor = doctor;
        let today = new Date();
        let d = today.getDate().toString();
        let m = (today.getMonth()+1).toString(); //January is 0!
        let y = today.getFullYear().toString();
        let dateTo=''
        let dateFrom=''

        if (d.length == 1) d='0'+d;
        if (m.length == 1) m='0'+m;
        dateTo+=d+'-'+m+'-'+y
        dateFrom+='01'+'-'+m+'-'+y

        this.id=this.doctor.id
        this.getInfo(dateFrom,dateTo,this.id);


      });
      this.callService.getStates().then( states => {
        for (const key in states) {
          this.callStates.push(states[key])
        }
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/doctors/detail/doctor-call-detail.component.ts